const colors = {
  positive: '#3ee85a',
  negative: '#be704c'
}

export {colors};